@if (searchResults && searchResults.length > 0) {
  <ul
    class="text-sm font-medium border rounded-lg bg-gray-100 border-gray-200 text-amazone-gray max-h-60 py-2 overflow-y-auto"
  >
    @for (result of searchResults; track $index) {
      <li
        [ngClass]="{
          'border-b': result && $index !== searchResults.length - 1,
          'border-b-lg': result && $index === searchResults.length - 1,
        }"
        class="w-full px-4 py-2 border-b border-gray-200 rounded-t-lg"
      >
        <a (click)="navigateToSearchResult(result)">
          <div class="flex items-center justify-between gap-4 cursor-pointer">
            <div class="flex-1 font-semibold truncate">
              {{ result.swPartNumber ?? 'N/A' }}
            </div>
            <div class="flex-1 truncate">
              {{ result.title ?? 'N/A' }}
            </div>
            <div class="flex-shrink-0">
              <app-open-page></app-open-page>
            </div>
          </div>
        </a>
      </li>
    }
  </ul>
}

<div appEscapeKeyDirective (escapeKeyPressed)="onEscape()">
  @if (noResults) {
    <div class="text-center mt-6">
      <span class="text-amazone-orange font-medium">No results</span>
    </div>
  }
  @if (invalidSearchTerm) {
    <div class="text-center mt-6">
      <span class="text-amazone-orange font-medium">Invalid DTC number</span>
    </div>
  }
</div>
